// removed by extract-text-webpack-plugin
module.exports = {"button":"UpdatePassword__button__MNkAx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/updatePassword/UpdatePassword.css
// module id = 6064
// module chunks = 0